import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as Fa from "react-icons/fa";
import React, { useState, useEffect } from "react";
import storage from "../../../Services/Storage";
import {
    createAPIEndpointSurveyFeedback,
    EndpointSurveyFeedback,
} from "../../../Services/SurveyFeedback/SurveyFeedbackService";
import Loader from "../../../Components/Loader";
import { useNavigate } from "react-router-dom";

const SurveyFeedback = () => {
    const navlink = useNavigate();
    const auth = storage.getLocal("user");
    const [surveyData, setSurveyData] = useState();
    const [loader, setLoader] = useState(false);

    const getLoadSurveryDeatilsByDate = async () => {
        try {
            setLoader(true);
            const response = await createAPIEndpointSurveyFeedback().get(
                `${EndpointSurveyFeedback.LoadSurveryDeatilsByDate}?UserId=${auth.UserId}`
            );
            setSurveyData(response.data);
        } catch (err) {
            console.log("Error ", err);
        } finally {
            setLoader(false);
        }
    };
    const renderAction = (rowdata) => {
        if(rowdata.STATUS === "Pending"){
            return (
                <>
                    <div className="action-icon">
                        <div
                            className="d-inline"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="View"
                        >
                            <button
                                className="grid-icon"
                                onClick={() => {
                                    navlink(
                                        `/helpdesk/surveyfeedback/view?surveyid=${encodeURIComponent(rowdata.SURVEY_ID)}`
                                    );
                                }}
                            >
                                <Fa.FaEye />
                            </button>
                        </div>
                    </div>
                </>
            );
        }
    };

    useEffect(() => {
        getLoadSurveryDeatilsByDate();
    }, []);

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <section>
                    <div className="col-md-12 col-lg-12 col-sm-12">
                        {loader ? <><Loader /></> : <div className="DataTable">
                            <DataTable
                                value={surveyData}
                                dataKey='QUESTION_ID'
                                paginator
                                rows={10}
                                scrollable
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                // showGridlines
                                stripedRows
                                editMode="row"
                                // onRowEditComplete={onRowEditComplete}
                                // globalFilterFields={["PROD_CODE", "DESCRIPTION"]}
                                emptyMessage="No record found."
                            >
                                <Column field="SURVEY_NO" header="Survey Number" />
                                <Column field="SURVEY_START_DATE" header="Survey Start Date" />
                                <Column field="SURVEY_END_DATE" header="Survey End Date" />
                                <Column field="STATUS" header="Completion Status" />
                                <Column field={renderAction} header="Action" />
                                {/* <Column header="Action" /> */}
                                {/* InputTextarea Here */}
                            </DataTable>
                        </div>}
                    </div>
                </section>
            </div>
        </>
    );
};

export default SurveyFeedback;
